import { Chip } from "@mui/material";
import { TLessonPlanStatus } from "../../../apis/lessonPlan/lessonPlan.interfaces";
import { ILoggedInUser } from "../../../apis/auth/auth.interfaces";

export const lessonPlanStatusOptions: TLessonPlanStatus[] = [
  "draft",
  "in_review",
  "approved",
  "active",
  "archived",
];

export const lessonPlanTermOptions = ["first", "second", "third"] as const;

const statusColor: Record<
  TLessonPlanStatus,
  "default" | "primary" | "success" | "warning" | "info"
> = {
  draft: "default",
  in_review: "warning",
  approved: "success",
  active: "info",
  archived: "default",
};

const statusLabel: Record<TLessonPlanStatus, string> = {
  draft: "Draft",
  in_review: "In Review",
  approved: "Approved",
  active: "Active",
  archived: "Archived",
};

export const renderLessonPlanStatusChip = (status: TLessonPlanStatus) => (
  <Chip
    size="small"
    label={statusLabel[status] ?? status}
    color={statusColor[status] ?? "default"}
    variant={status === "draft" || status === "archived" ? "outlined" : "filled"}
  />
);

export const formatTerm = (term?: string) => {
  if (!term) return "—";
  return term.charAt(0).toUpperCase() + term.slice(1);
};

export const formatStatusLabel = (status: TLessonPlanStatus | string) =>
  statusLabel[status as TLessonPlanStatus] ?? status;

// PATCH/DELETE/archive are gated on the BE to super_admin + admin_role. The JWT carries
// a single role string (user.role); any other value (student, teacher, internal_staff,
// guardian, etc.) is denied.
export const canManageLessonPlans = (
  user: ILoggedInUser | null | undefined,
): boolean =>
  user?.role === "super_admin" || user?.role === "admin_role";
